'use client';

import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect, useRef } from 'react';

import { pushGTMEvent } from '@/utils/pushGTMEvent';

interface Props {
  eventData: Record<string, any>;
}

export const TrackVirtualPageview = ({ eventData }: Props) => {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const previousPath = useRef<string | null>(null);
  const hasTracked = useRef(false);

  useEffect(() => {
    const fullPath = `${pathname}?${searchParams.toString()}`;

    // Only fire if the path changes or if this is the first render
    if (previousPath.current !== fullPath || !hasTracked.current) {
      previousPath.current = fullPath;
      hasTracked.current = true;

      pushGTMEvent({
        event: 'virtual_pageview',
        page_path: pathname,
        ...eventData,
      });
    }
  }, [pathname, searchParams, eventData]);

  return null;
};
